import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useSite } from "@/context/SiteContext";

export const Footer = () => {
  const { site } = useSite() || {};
  return (
    <footer className="relative border-t border-[#C9A24B]/25 bg-[#0B1D14]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Logo size={44} />
          <p className="mt-6 font-accent italic text-2xl md:text-3xl text-[#E4C87F] max-w-md" data-testid="footer-slogan">{site?.slogan || "Every leaf or every branches makes a great tree"}</p>
        </div>
        <div className="flex flex-col gap-3 text-sm">
          <p className="label">Explore</p>
          {[["/story", "Our Story"], ["/tree", "Family Tree"], ["/gallery", "Gallery"], ["/memoriam", "In Memoriam"]].map(([to, l]) => (
            <Link key={to} to={to} className="sweep w-fit text-[#F6EFE0]/80 hover:text-[#F6EFE0]">{l}</Link>
          ))}
        </div>
        <div className="flex flex-col gap-3 text-sm">
          <p className="label">Family</p>
          <Link to="/gate" className="sweep w-fit text-[#F6EFE0]/80 hover:text-[#F6EFE0]" data-testid="footer-gate-link">Family Members Only</Link>
          <Link to="/privacy" className="sweep w-fit text-[#F6EFE0]/80 hover:text-[#F6EFE0]" data-testid="footer-privacy-link">Privacy: who can see what</Link>
        </div>
      </div>
      <div className="border-t border-[#C9A24B]/15">
        <p className="max-w-7xl mx-auto px-6 md:px-10 py-6 text-xs tracking-[0.12em] text-[#F6EFE0]/70" data-testid="footer-copyright">{site?.footer_text || "\u00a9 2006 MARAIS FAMILY. All rights reserved."}</p>
      </div>
    </footer>
  );
};
